import api from './api'

// 중복 저장 방지를 위한 디바운싱
let saveTimeout = null
let lastSaveData = null

export const userPlaylistService = {
  // 사용자 재생목록 조회
  async getUserPlaylist(userId) {
    try {
      console.log('사용자 재생목록 조회:', userId)
      const response = await api.get(`/userplaylist/${userId}`)
      console.log('재생목록 조회 성공:', response.data)
      return response.data
    } catch (error) {
      console.error('재생목록 조회 실패:', error)
      return []
    }
  },

  // 사용자 재생목록 저장 (디바운싱 적용)
  async saveUserPlaylist(userId, playlist) {
    try {
      // 동일한 데이터인지 확인
      const currentDataKey = `${userId}-${playlist.length}-${JSON.stringify(playlist.slice(0, 3))}`

      if (lastSaveData === currentDataKey) {
        console.log('🚫 동일한 재생목록 저장 요청 무시:', { userId, count: playlist.length })
        return { message: '동일한 데이터로 저장 건너뜀' }
      }

      // 이전 타이머 취소
      if (saveTimeout) {
        clearTimeout(saveTimeout)
      }

      // 100ms 후 저장 (짧은 디바운싱)
      return new Promise((resolve, reject) => {
        saveTimeout = setTimeout(async () => {
          try {
            console.log('💾 디바운싱된 재생목록 저장:', { userId, count: playlist.length })
            lastSaveData = currentDataKey

            // duration을 초 단위 정수로 변환하는 함수
            const parseDurationToSeconds = (duration) => {
              if (!duration) return 0
              if (typeof duration === 'number') return duration
              if (!isNaN(Number(duration))) return Number(duration)

              if (typeof duration === 'string') {
                const parts = duration.split(':').map(p => parseInt(p, 10))
                if (parts.length === 2) {
                  return parts[0] * 60 + parts[1]
                } else if (parts.length === 3) {
                  return parts[0] * 3600 + parts[1] * 60 + parts[2]
                }
              }
              return 0
            }

            // 프론트엔드 형식을 백엔드 형식으로 변환
            const playlistData = {
              userId: userId,
              playlist: playlist.map((song, index) => ({
                id: song.id, // 데이터베이스 ID (SongId로 Sections 조회 가능)
                youtubeId: song.youtubeId || song.videoId,
                title: song.title,
                artist: song.artist || song.channelTitle,
                thumbnailUrl: song.thumbnailUrl || song.thumbnail,
                duration: parseDurationToSeconds(song.duration),
                playOrder: index
                // sections는 저장 안 함 - 이미 Sections 테이블에 있음
              }))
            }

            console.log('📤 백엔드로 전송할 데이터:', JSON.stringify(playlistData, null, 2))

            const response = await api.post('/userplaylist', playlistData)
            console.log('재생목록 저장 성공:', response.data)
            resolve(response.data)
          } catch (error) {
            console.error('❌ 재생목록 저장 실패:', error)
            if (error.response) {
              console.error('❌ 응답 상태:', error.response.status)
              console.error('❌ 응답 데이터:', error.response.data)
            }
            reject(error)
          }
        }, 100)
      })
    } catch (error) {
      console.error('재생목록 저장 실패:', error)
      throw error
    }
  },

  // 사용자 재생목록 삭제
  async clearUserPlaylist(userId) {
    try {
      console.log('사용자 재생목록 삭제:', userId)
      const response = await api.delete(`/userplaylist/${userId}`)
      console.log('재생목록 삭제 성공:', response.data)
      return response.data
    } catch (error) {
      console.error('재생목록 삭제 실패:', error)
      throw error
    }
  }
}